import { Component, OnInit, ViewChild } from '@angular/core';

import { BcCircleLoadingComponent } from '@bancolombia/design-system-web/bc-circle-loading';

import { FacturaEstadoModel, FacturaModel } from 'src/app/domain/models/factura/factura.model';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';
import { BuscadorModel } from '../../../shared/components/interfaces/buscador-model.interface';
import { FacturaEstadoUseCase } from 'src/app/domain/usecases/factura-estado/factura-estado.usecase';
import { FloatMenuOptionsModel } from 'src/app/domain/models/factura/float-menu-options.model';
import { AppModalUseCase } from 'src/app/domain/usecases/app-modal/app-modal.usecase';

@Component({
  selector: 'factura-home',
  templateUrl: './factura-home.component.html',
  styleUrls: ['./factura-home.component.css']
})
export class FacturaHomeComponent {

  @ViewChild(BcCircleLoadingComponent, { static: false })
  bcCircleLoading!: BcCircleLoadingComponent;

  dataFactura: FacturaModel | undefined;
  formData: BuscadorModel = { data: '', option: '', estado: '' }

  titulo: string = 'Gestión de facturas';

  /* Modal Shared */
  isModal: boolean = false;
  titleModal: string = ''
  typeIconModal: any = ''
  bodyModal: string = ''
  subBodyModal: string = ''
  /* End Modal Shared */

  circleLoadingText = "Consultando...";
  circleLoadingAriaLabel = "";
  loaderSpeed = "0.5";

  isReporte: boolean = false;

  floatMenuOptions: FloatMenuOptionsModel[];

  dataTablePageStart = 0;
  dataTablePageEnd = 5;
  dataTablePage: [number, number] = [this.dataTablePageStart,this.dataTablePageEnd];

  ngAfterViewInit() {    
    this.facturaFindAll();
    this.construirFacturaEstado();
  }

  constructor(
    private facturaUseCase: FacturaUseCase,
    private facturaEstadoUseCase: FacturaEstadoUseCase,
    private appModalUseCase: AppModalUseCase) {
    this.floatMenuOptions = [];
  }

  construirFacturaEstado(): void {
    if (this.facturaEstadoUseCase.comprobarEstadosFacturaLocalStorage()) {
      this.floatMenuOptions = this.facturaEstadoUseCase.getFacturaEstadoLocalStorage();
      this.facturaEstadoUseCase.estadosFacConbaseEnRol();
    } else {
      this.facturaEstadoFindAll();
    }

  }

  facturaEstadoFindAll(): void {
    this.isModal = false;

    this.facturaEstadoUseCase.findAll()
      .subscribe({
        next: (resFactura: FacturaEstadoModel[]) => {
          this.isModal = false;

          //Guarda en LocalStorage el resultado
          this.facturaEstadoUseCase.guardarFacturaEstadoLocalStorage(resFactura);          
          this.construirFacturaEstado();
          this.facturaEstadoUseCase.estadosFacConbaseEnRol();
        },
        error: () => {
          this.modalFindErrorMessages();
          this.isModal = true;
        },
      });
  }


  eventoBuscadorFormDataEvent(data: BuscadorModel): void {
    this.resetDataTablePage();

    this.formData.data = data.data;
    this.formData.option = data.option;
  }

  eventoBuscador(data: boolean): void {
    this.resetDataTablePage();
    this.facturaFindAll();
  }

  facturaFindAll(): void {
    this.bcCircleLoading.showCircleLoading();
    this.isModal = false;


    this.facturaUseCase.findAll(
      this.dataTablePage[0], 
      this.dataTablePage[1], 
      this.formData.data, 
      this.formData.option,
      this.formData.estado)
      .subscribe({
        next: resFactura => {
          this.isModal = false;
          this.dataFactura = resFactura;
          this.bcCircleLoading.hideCircleLoading();
        },
        error: () => {
          this.bcCircleLoading.hideCircleLoading();
          this.modalFindErrorMessages();
          this.isModal = true;
        },
      });
  }

  onChangePageTable(data: [number, number]) {    
    this.dataTablePage = data;
    this.facturaFindAll();
  }

  isErrorExportEvent(data: boolean): void {
    this.procesarModalEvent(data);
  }

  procesarModalEvent(data: boolean): void {
    this.isModal = data;
    if (data) {
      this.modalFindErrorMessages();
    }
  }

  modalFindErrorMessages(): void {
    const [titleModal, typeIconModal, bodyModal, subBodyModal] = this.appModalUseCase.modalFindErrorMessages();
    this.titleModal = titleModal;
    this.typeIconModal = typeIconModal;
    this.bodyModal = bodyModal;
    this.subBodyModal = subBodyModal;
  }

  eventoFiltroEstado(event: any): void {
    this.resetDataTablePage();
    const { optionSeleted } = event;
    this.formData.estado = optionSeleted.id;
    this.facturaFindAll();
  }

  resetDataTablePage(){
    this.dataTablePage = [this.dataTablePageStart,this.dataTablePageEnd];
  }
}
